import React from "react";

import { faLongArrowAltDown } from "@fortawesome/pro-solid-svg-icons/faLongArrowAltDown";
import { faLongArrowAltUp } from "@fortawesome/pro-solid-svg-icons/faLongArrowAltUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Col from "antd/es/col";
import Row from "antd/es/row";

import styles from "./RankDiff.module.scss";

interface Props {
  rankDiff?: number;
}

const RankDiff: React.FC<Props> = ({ rankDiff }) => {
  return rankDiff !== undefined && rankDiff !== 0 ? (
    <Row className={styles.rankDiffValue}>
      <Col>
        <FontAwesomeIcon
          className={rankDiff > 0 ? styles.arrowUp : styles.arrowDown}
          icon={rankDiff > 0 ? faLongArrowAltUp : faLongArrowAltDown}
        />
      </Col>
      <Col className={styles.value}>{Math.abs(rankDiff)}</Col>
    </Row>
  ) : null;
};

export default RankDiff;
